<template>
    <div>
        <b-modal
            id="resultTask"
            title="Desempenho da Turma"
            size="xl"
            body-bg-variant="light"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <div v-if="task">

                    <b-row class="mb-4">
                        <b-col sm="6">
                            <b-card title="Qtd. de Redações">
                                <div class="h2 font-weight-bold">
                                    {{ results.count }}
                                </div>
                            </b-card>
                        </b-col>
                        <b-col sm="6">
                            <b-card title="Média das Notas">
                                <div class="h2 font-weight-bold">
                                    {{ results.avg }}
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-card class="mb-4">

                        <!-- Field -->
                        <chart-field :chart-data="results.chartFields"></chart-field>

                    </b-card>

                    <b-table
                        :items="results.essays"
                        :fields="results.essaysFields"
                        empty-text="Não há redações para analisar :("
                        class="bg-white"
                        stacked="md"
                        :sticky-header="true"
                        show-empty
                        bordered
                        hover>

                        <template v-for="field in results.fields" v-slot:[`cell(${field})`]="row">

                            <span v-for="result in row.item.results" :key="result.id">
                                <span v-if="result.field.name === field">
                                    {{ result.value }}
                                </span>
                            </span>

                        </template>

                        <template v-slot:cell(note)="row" >
                            <span class="font-weight-bold">
                                {{ row.item.note }}
                            </span>
                        </template>

                    </b-table>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import ChartField from "../reports/ChartField";

export default {
    components: {
        ChartField
    },
    data() {
        return {
            loading: false,
            task: null,
            id: null,
            results: {
                count: 0,
                avg: 0,
                chartFields: [],
                essays: [],
                essaysFields: [],
                fields: []
            },
        }
    },
    created() {

        this.$root.$on('resultsTask', (task) => {
            this.task = task;
            this.id = task.id;
            this.$bvModal.show('resultTask')
            this.load()
        })

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/tasks/' + this.id + '/results')
                .then((result) => {
                    this.results = result.data.data.results;
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
